// src/pages/platform/HowItWorks.tsx

import React from "react";

import {
  Link,
} from "react-router-dom";

import "./PlatformPages.css";


const steps = [
  {
    number: "01",
    symbol: "♠",
    title: "Create Your Account",
    description:
      "Register for P-ARENA so your player identity, profile, and supported game statistics can be associated with your account.",
  },
  {
    number: "02",
    symbol: "♥",
    title: "Enter the Game House",
    description:
      "Explore the P-ARENA collection and choose an available game. Fasoor is the first playable game on the platform.",
  },
  {
    number: "03",
    symbol: "♦",
    title: "Choose How to Play",
    description:
      "Select from the play modes currently supported by the game, including AI and multiplayer experiences as available.",
  },
  {
    number: "04",
    symbol: "♣",
    title: "Play the Game",
    description:
      "Enter the game table and compete according to the rules and scoring system of the selected game.",
  },
  {
    number: "05",
    symbol: "★",
    title: "Build Your Record",
    description:
      "Supported completed games contribute to your player statistics such as games played, wins, losses, and scores.",
  },
];


const HowItWorks: React.FC = () => {

  return (
    <main className="platform-page">

      <section className="platform-hero">

        <div className="platform-hero-glow" />

        <div className="platform-hero-content">

          <nav
            className="platform-breadcrumb"
            aria-label="Breadcrumb"
          >
            <Link to="/">
              P-ARENA
            </Link>

            <span>/</span>

            <strong>
              How It Works
            </strong>
          </nav>


          <div className="platform-emblem">
            ♦
          </div>

          <p className="platform-eyebrow">
            GETTING STARTED
          </p>

          <h1>
            How It Works
          </h1>

          <p className="platform-hero-description">
            From creating your account to
            entering the table, getting started
            with P-ARENA is straightforward.
          </p>

        </div>

      </section>


      <div className="platform-content">

        {/* =========================================== */}
        {/* STEPS                                       */}
        {/* =========================================== */}

        <section className="platform-section">

          <div className="platform-section-heading">

            <span>
              01
            </span>

            <div>
              <p>
                THE P-ARENA EXPERIENCE
              </p>

              <h2>
                From Player to Arena
              </h2>
            </div>

          </div>


          <div className="platform-steps">

            {steps.map(
              (step) => (

                <article
                  key={step.number}
                  className="platform-step"
                >

                  <div className="platform-step-number">
                    {step.number}
                  </div>


                  <div className="platform-step-symbol">
                    {step.symbol}
                  </div>


                  <div className="platform-step-content">

                    <h3>
                      {step.title}
                    </h3>

                    <p>
                      {step.description}
                    </p>

                  </div>

                </article>

              )
            )}

          </div>

        </section>


        {/* =========================================== */}
        {/* PLAY MODES                                  */}
        {/* =========================================== */}

        <section className="platform-section">

          <div className="platform-section-heading">

            <span>
              02
            </span>

            <div>
              <p>
                GAME MODES
              </p>

              <h2>
                Choose Your Opponent
              </h2>
            </div>

          </div>


          <div className="platform-feature-grid">

            <article>

              <span>
                AI
              </span>

              <h3>
                AI Opponent
              </h3>

              <p>
                Start a supported game against
                a computer-controlled opponent.
              </p>

            </article>


            <article>

              <span>
                02
              </span>

              <h3>
                Friends
              </h3>

              <p>
                Play directly with another
                person when the game's friend
                multiplayer mode is available.
              </p>

            </article>


            <article>

              <span>
                ∞
              </span>

              <h3>
                Online Players
              </h3>

              <p>
                Use online matchmaking where
                supported to compete with
                another P-ARENA player.
              </p>

            </article>

          </div>

        </section>


        {/* =========================================== */}
        {/* ACCOUNT                                     */}
        {/* =========================================== */}

        <section className="platform-highlight">

          <div>

            <p className="platform-mini-label">
              YOUR PLAYER PROFILE
            </p>

            <h2>
              Your Games Become Part
              of Your Record.
            </h2>

            <p>
              P-ARENA can maintain statistics
              for supported completed games,
              including games played, wins,
              losses, scores, and other
              game-specific information.
            </p>

            <Link
              to="/profile"
              className="platform-secondary-button"
            >
              View Player Profile
            </Link>

          </div>


          <div className="platform-highlight-mark">
            P
          </div>

        </section>


        {/* =========================================== */}
        {/* CTA                                         */}
        {/* =========================================== */}

        <section className="platform-cta">

          <div className="platform-suits">
            ♠ ♥ ♦ ♣
          </div>

          <p className="platform-eyebrow">
            YOUR TURN
          </p>

          <h2>
            Enter P-ARENA
          </h2>

          <p>
            Choose a game, find your opponent,
            and take your seat at the table.
          </p>

          <div className="platform-inline-actions">

            <Link
              to="/game-house"
              className="platform-primary-button"
            >
              Explore Games
            </Link>

            <Link
              to="/register"
              className="platform-secondary-button"
            >
              Create Account
            </Link>

          </div>

        </section>

      </div>

    </main>
  );
};


export default HowItWorks;